import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { HttpClient, HttpEventType } from '@angular/common/http';
import { UploadService } from '../../services/upload.service';
import { MatCardModule } from '@angular/material/card';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { ErrorDialogComponent } from '../../utility components/error-dialog/error-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import {MatDialogModule} from '@angular/material/dialog';
import { LoaderComponent } from '../../utility components/loader/loader.component';
import { NormalModeService } from '../../services/normal_mode.service';



@Component({
    selector: 'app-upload-form',
    imports: [FormsModule, MatCardModule,
      MatSelectModule,
      MatFormFieldModule,
      MatInputModule,
      MatButtonModule,FormsModule,
      ReactiveFormsModule,CommonModule,MatIcon,MatDialogModule,
      ErrorDialogComponent,LoaderComponent],
    templateUrl: './upload-form.component.html',
    styleUrl: './upload-form.component.css',
    standalone: true
})
export class UploadFormComponent {

  @Input() receivedFile: File | null = null;
  @Output() openPopup = new EventEmitter<void>();
  @Output() loadingStateChange = new EventEmitter<boolean>();
  uploadForm: FormGroup;
  selectedMode: string = 'EXPLORE';
  selectedCsvFiles: File[] = [];
  selectedConfigFile: File | null = null;
  configFileName: string = '';
  csvFileName: string = '';
  isLoading: boolean = false;
  channel: string = 'inbound';


  constructor(private fb: FormBuilder, private router: Router, private http: HttpClient,
    private uploadService: UploadService,
    private normalModeService: NormalModeService,
    private dialog: MatDialog) {
    this.uploadForm = this.fb.group({
      DEXCAT_MODE: ['EXPLORE'],
      data: [null],
      config: [null]
    });
  }

  showError(message: string): void {
    if (!this.dialog) {
      console.error("MatDialog is not initialized.");
      return;
    }

    this.dialog.open(ErrorDialogComponent, {
      data: { message }
    });
  }

  triggerPopup(){
    this.openPopup.emit();
  }


  onCsvFileChange(event: any): void {
    if (event.target.files.length > 0) {
      this.selectedCsvFiles = Array.from(event.target.files); // Store all selected files
      console.log('Selected CSV files:', this.selectedCsvFiles.map(file => file.name));
    }
  }

  onConfigFileChange(event: any): void {

    const file: File = event.target.files[0];
    if (file && file.type === 'application/json') {
      this.selectedConfigFile = file;
      if (this.selectedConfigFile) {
        this.configFileName=this.selectedConfigFile.name;
      }

      console.log('Selected JSON config file:', file.name);
    } else {
      alert('Please select a valid JSON file.');

      event.target.value = '';  // Clear the input
      this.selectedConfigFile = null;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['receivedFile'] && this.receivedFile) {
      this.handleReceivedFile();
    }
  }

  handleReceivedFile(): void {
    if (this.receivedFile && this.receivedFile.type === 'application/json') {
      this.selectedConfigFile = this.receivedFile;
      this.configFileName = this.receivedFile.name;
      console.log('Auto-uploading received JSON config file:', this.configFileName);

     // Short delay to ensure UI updates before submission
    } else {
      console.error('Invalid file type received');
    }
  }


  submitFiles(): void {
    if (!this.selectedMode) {
      this.showError('Please select a mode before submitting.');
      return;
    }

    this.isLoading = true;
    this.loadingStateChange.emit(this.isLoading);

    if (this.selectedMode === 'NORMAL') {
      // Call NormalModeService for Normal Mode
      this.normalModeService.fetchNormalModeData().subscribe({
        next: (response) => {
          if (!response || Object.keys(response).length === 0) {
            this.showError('No data available for Normal Mode.');
            this.isLoading = false;
            this.loadingStateChange.emit(this.isLoading);
            return;
          }
          this.normalModeService.setResponseData(response);
          this.isLoading = false;
          this.loadingStateChange.emit(this.isLoading);
          this.router.navigate(['/normal-output']);
        },
        error: () => {
          this.showError('Failed to fetch data for Normal Mode.');
          this.isLoading = false;
          this.loadingStateChange.emit(this.isLoading);
        }
      });

    } else if (this.selectedMode === 'EXPLORE') {
      if (!this.selectedCsvFiles || this.selectedCsvFiles.length === 0) {
        this.showError('Please upload a CSV file.');
        this.isLoading = false;
        this.loadingStateChange.emit(this.isLoading);
        return;
      }
      if (!this.selectedConfigFile) {
        this.showError('Please upload a Config file.');
        this.isLoading = false;
        this.loadingStateChange.emit(this.isLoading);
        return;
      }

      const formData = new FormData();
      formData.append('DEXCAT_MODE', this.selectedMode);
      const sessionid=Math.random().toString(36).substring(2) + Date.now().toString(36);
      formData.append('session_id',sessionid);
      localStorage.setItem('sessionid',sessionid);
      this.selectedCsvFiles.forEach((file) => formData.append('data', file));
      formData.append('config', this.selectedConfigFile);
      formData.append('DEXCAT_EXPLORE_MODE', this.channel);


      this.uploadService.uploadFiles(formData).subscribe({
        next: (response) => {
          if (!response || Object.keys(response).length === 0) {
            this.showError('Upload failed. No response from the server.');
            this.isLoading = false;
            this.loadingStateChange.emit(this.isLoading);
            return;
          }
          this.uploadService.setResponseData(response);
          this.isLoading = false;
          this.loadingStateChange.emit(this.isLoading);
          setTimeout(() => {
            this.router.navigate(['/explore-output']);
          }, 500);
        },
        error: () => {
          this.showError('Upload failed. Please try again.');
          this.isLoading = false;
          this.loadingStateChange.emit(this.isLoading);
        }
      });
    } else {
      this.showError('Invalid mode selected.');
      this.isLoading = false;
      this.loadingStateChange.emit(this.isLoading);
    }
  }

  
}

